import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import { FaSearch } from "react-icons/fa"
import TextHighlighter from "./highlight"
import { Wrapper, ResultWrapper } from "./style"

const SearchResult = props => {
  // 全記事データ取得 //
  const { allMarkdownRemark } = useStaticQuery(graphql`
    query SearchData {
      allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: DESC }
        limit: 1000
      ) {
        edges {
          node {
            id
            html
            frontmatter {
              title
              date(formatString: "YYYY-MM-DD")
              slug
              tags
            }
          }
        }
      }
    }
  `)
  const [data, setData] = useState([])
  useEffect(() => {
    setData(
      allMarkdownRemark.edges.map(e => { return e.node })
    )
  }, [allMarkdownRemark])

  // 表示非表示の切り替え //
  const [className, setClassName] = useState("")
  useEffect(() => {
    let id
    if (props.focus && props.value !== "") {
      id = setTimeout(() => {
        setClassName("active")
      }, 100)
    } else {
      id = setTimeout(() => {
        setClassName("")
      }, 100)
    }
    return () => {
      clearTimeout(id)
    }
  }, [props.focus, props.value])

  // 索処理 //
  const [result, setResult] = useState([])
  useEffect(() => {
    if (props.value) {
      const value = props.value.toLowerCase().trim()
      const resultArray = []
      data.forEach(e => {
        if (e.frontmatter.title.toLowerCase().indexOf(value) !== -1) {
          // タイトルのマッチは必ず先頭に追加する
          resultArray.unshift({
            id: e.id,
            slug: e.frontmatter.slug,
            str: e.frontmatter.title,
          })
        } else {
          // タグをひとつひとつ検査する
          e.frontmatter.tags.forEach(tag => {
            if (tag.toLowerCase().indexOf(value) !== -1) {
              resultArray.push({
                id: e.id,
                slug: e.frontmatter.slug,
                str: `#${tag}, ${e.frontmatter.title}`
              })
            }
          })
        }
      })
      setResult(resultArray)
    }
  }, [data, props.value])

  return (
    <ResultWrapper className={className}>
      <div className="result-inner">
        <span className="res">
          <b>{result.length}</b>件ヒットしました
        </span>
        <ul>
          {result.map(e => {
            return (
              <li key={e.id}>
                <Link to={`/${e.slug}/`}>
                  <TextHighlighter str={e.str} includes={props.value.toLowerCase().trim()} />
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </ResultWrapper>
  )
}

const Search = props => {
  const [focus, setFocus] = useState(false)
  const [value, setValue] = useState("")
  const onFocus = () => {
    setFocus(true)
  }
  const onBlur = () => {
    setFocus(false)
  }
  const onChange = e => {
    setValue(e.target.value)
  }
  return (
    <Wrapper className={props.className} focus={focus}>
      <FaSearch />
      <input
        type="text"
        placeholder="Search..."
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
      />
      <SearchResult focus={focus} value={value} />
    </Wrapper>
  )
}

export default Search
